import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import {Toaster} from 'react-hot-toast';
import AdminLayout from "./AdminLayout/AdminLayout.jsx";
import DashboardPage from "./AdminPages/Dashboard.jsx";
import ProductsPage from "./AdminPages/ProductsPage.jsx";
import OrdersPage from "./AdminPages/OrdersPage.jsx";
import UsersPage from "./AdminPages/UsersPage.jsx";
import AdminLogin from "./AdminLogin/login.jsx";
import QueriesPage from "./AdminPages/QueriesPage.jsx";
// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("adminToken");

  if (isAuthenticated) {
    return children;
  }

  // If not logged in, redirect to login
  return <Navigate to="/" replace />;
};

// Redirect if already logged in
const PublicRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("adminToken");

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
    <Toaster position="top-right" toastOptions={{ duration: 2000 }} />
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />

        {/* Protected Admin Routes */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="queries" element={<QueriesPage />} />
        </Route>

        {/* Fallback for unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;